import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StateDropdown from './StateDropdown'
import SearchDropdown from './SearchDropdown'
import Searchbar from './Searchbar'
import { loadLineitems, switchSearchFilter, switchStateFilter, resetFilters } from '../actions'

class Filter extends Component {

  componentDidMount(){
    this.props.actions.resetFilters()
  }

  onSwitchStatefilter = (state) => {
    const { limit, sort, actions } = this.props
    if (state === "LAUNCHED,AWAITING_APPROVAL") {
      actions.loadLineitems({
        qaState: "PRE_APPROVE,PRE_APPROVED,POST_APPROVED",
        state, 
        limit, 
        sort
      })
    } else {
      actions.loadLineitems({state, limit, sort})
    }
    actions.switchStateFilter(state)
  };

  onSwitchSearchfilter = (field) => {
    this.props.actions.switchSearchFilter(field)
  };

  onSearch = (value) => {
    const { users } = this.props;
    const { selectedSearchField, selectedState } = this.props.filter;

    if(selectedSearchField === "user.assignedTo") {
      const user = users.find(u => u.name.toLowerCase().indexOf(value.toLowerCase()) > -1)
      value = user ? user.email : value;
    }
    
    this.props.actions.loadLineitems({ 
      [selectedSearchField]: value, 
      state: selectedState
    })
  };

  render() {
    return (
      <div className="filter-bar">
        <StateDropdown 
          onSwitchStatefilter={this.onSwitchStatefilter} />
        <SearchDropdown 
          onSwitchSearchfilter={this.onSwitchSearchfilter}
          columns={this.props.columns} />
        <Searchbar 
          onSearch={this.onSearch} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { filter } = state
  return { filter }
}

function mapDispatchToProps(dispatch) {
  const actions = { 
    loadLineitems, 
    switchSearchFilter, 
    switchStateFilter,
    resetFilters
   }
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter)